import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import '@/pages/timeline/sections/timeline/timelineSections/certificate/style.css'
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import { notifyParentToExtendCourse } from '@/utils/mainSiteNavigateFromIframe';

export default function ExtendDuration(props: any) {
    const { timeline, common } = useLocalTranslation();
    const timelineDetails = useSelector((state: RootState) => state.timelineReducer.timeline);

    const handleExtentDuration = () => {
        if (!timelineDetails?.courseSeoUrlSlug) return;
        
        notifyParentToExtendCourse({
            courseSeoUrlSlug: timelineDetails.courseSeoUrlSlug
        });
    }

    return (
        <div className='commonMainCon'>
            <p className='commonp1 mb-[8px] text-[#FD3535] font-bold'>{timeline.certificateSection.extendDuration.h1}</p>
            <p className='commonp1 mb-[15px]'>
                {timeline.certificateSection.extendDuration.p1}{" "}
                <button
                    onClick={handleExtentDuration}
                    className='text-[#0173e7] font-semibold'>
                    {common.statusText.extendDuration}
                </button>
            </p>
            <button
                disabled
                className='commonb1 commonb1_bg_grey cursor-not-allowed'>
                {common.statusText.claimYourCertificate}
            </button>
        </div>
    );
};
